import axios, { AxiosRequestConfig } from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

const updateHeader = (request: AxiosRequestConfig) => {
  const token = sessionStorage.getItem('accessToken');
  const newHeaders = {
    Authorization: `Bearer ${token}`,
  };
  request.headers = { ...request.headers, ...newHeaders };
  return request;
};

// @ts-ignore
axiosInstance.interceptors.request.use((request) => {
  if (request.headers) {
    request.headers['Content-Type'] = 'application/json';
  }
  return updateHeader(request);
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || 'Something went wrong'
    )
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  permission: '/api/permission',
  parameter: '/api/parameter',
  job: '/api/job',
  role: '/api/role',
  userRoles: {
    get: '/api/role/GetUserRoles',
    update: '/api/role/UpdateUserRoles',
  },
  roleHierarchy: {
    get: '/api/role/GetRoleHierarchy',
    update: '/api/role/UpdateRoleHierarchy',
  },
  logViewer: {
    get: '/api/LogViewer',
    getLogFile: '/api/LogViewer/GetLogFile',
    getLogs: '/api/LogViewer/GetLogs',
  },
  viewPermissions: '/api/permission/GetViewPermissions',
  entityPermissions: '/api/permission/GetEntityPermissions',
  actionPermissions: '/api/permission/GetActionPermissions',
  roleViewPermissions: '/api/permission/GetRoleViewPermissions',
  roleEntityPermissions: '/api/permission/GetRoleEntityPermissions',
  roleActionPermissions: '/api/permission/GetRoleActionPermissions',
  updatePermissions: '/api/permission/UpdatePermissions',
  user: '/api/user',
  getCurrentUser: '/api/user/GetCurrentUser',
  initialUser: '/api/user/InsertFirstUser',
  validateFirstUser: '/api/user/ValidateFirstUser',
  auth: {
    me: '/api/auth/me',
    login: '/api/Auth/Login',
    register: '/api/auth/register',
    auth: '/api/Auth/AuthUser',
  },
  actions: {
    generarCotizacion: '/api/view/Cotizacion/GenerarCotizacion',

    enviarEmailCotizacion: '/api/view/Cotizacion/EnviarEmailCotizacion',

    aprobarCotizacion: '/api/view/Cotizacion/AprobarCotizacion',

    eliminarCotizacion: '/api/view/Cotizacion/EliminarCotizacion',

    descuentoCotizacion: '/api/view/Cotizacion/DescuentoCotizacion',

    copiarCotizacion: '/api/view/Cotizacion/CopiarCotizacion',

    anularCotizacion: '/api/view/Cotizacion/AnularCotizacion',

    rechazarCotizacion: '/api/view/Cotizacion/RechazarCotizacion',

    cancelarCotizacion: '/api/view/Cotizacion/CancelarCotizacion',

    revertirCotizacion: '/api/view/Cotizacion/RevertirEstadoCotizacion',

    exportarCotizacionAPdf: '/api/view/Cotizacion/GenerateReport',
    exportarCotizacionAPdfView: '/api/view/Cotizacion/GenerateReportView',
    exportarComprasAPdfView: '/api/view/Compras/GenerateReportView',

    exportarOrdenAPdf: '/api/view/Orden/GenerateReport',
    exportarOrdenAPdfMoka: '/api/view/Orden/GenerateReportMoka',

    adelantoOrden: '/api/view/Orden/AdelantoOrden',

    remitoOrden: '/api/view/Orden/RemitoOrden',

    facturarOrden: '/api/view/Orden/FacturarOrden',

    anularOrdenF: '/api/view/Orden/AnularOrdenF',

    revertirOrden: '/api/view/Orden/RevertirEstadoOrden',

    marcarRecibidaOrdenF: '/api/view/Orden/MarcarRecibidaOrdenF',

    marcarPlanificadaOrdenF: '/api/view/Orden/MarcarPlanificadaOrdenF',

    verificarStockOrden: '/api/view/Orden/VerificarStock',
    verificarStockCoti: '/api/view/Cotizacion/VerificarStock',

    marcarEnProduccionOrdenF: '/api/view/Orden/MarcarEnProduccionOrdenF',

    terminarOrdenF: '/api/view/Orden/TerminarOrdenF',

    marcarControladaOrdenF: '/api/view/Orden/MarcarControladaOrdenF',

    marcarDespachadaOrdenF: '/api/view/Orden/MarcarDespachadaOrdenF',

    rechazarOrdenF: '/api/view/Orden/RechazarOrdenF',

    finalizarOrdenF: '/api/view/Orden/FinalizarOrdenF',

    darDeBajaClienteF: '/api/view/Cliente/DarDeBajaClienteF',

    darDeAltaClienteF: '/api/view/Cliente/DarDeAltaClienteF',

    verificarClienteF: '/api/view/Cliente/VerificarClienteF',

    discontinuarProductoF: '/api/view/Producto/DiscontinuarProductoF',

    verificarProducto: '/api/view/Producto/VerificarProducto',

    actualizarProducto: '/api/view/Producto/ActualizarProducto',

    verificarMatrizF: '/api/view/Matriz/ValidarMatrizF',

    discontinuarMatriz: '/api/view/Matriz/DiscontinuarMatriz',

    marcarAveriadaMatrizF: '/api/view/Matriz/MarcarAveriadaMatrizF',

    marcarEnReparacionMatrizF: '/api/view/Matriz/MarcarEnReparacionMatrizF',

    marcarEnviadaFacturacionF:
      '/api/view/Facturacion/MarcarEnviadaFacturacionF',

    marcarPagadaFacturacionF: '/api/view/Facturacion/MarcarPagadaFacturacionF',

    marcarAdeudadaFacturacionF:
      '/api/view/Facturacion/MarcarAdeudadaFacturacionF',

    marcarEnviadoRemitoF: '/api/view/Remito/MarcarEnviadoRemitoF',

    marcarRecepcionadoRemitoF: '/api/view/Remito/MarcarRecepcionadoRemitoF',

    marcarEnviadoReciboF: '/api/view/Recibo/MarcarEnviadoReciboF',

    marcarRecepcionadoReciboF: '/api/view/Recibo/MarcarRecepcionadoReciboF',

    marcarPlanificadoProyectoF: '/api/view/Proyecto/MarcarPlanificadoProyectoF',

    marcarEnProcesoProyectoF: '/api/view/Proyecto/MarcarEnProcesoProyectoF',

    marcarDemoradoProyectoF: '/api/view/Proyecto/MarcarDemoradoProyectoF',

    marcarFinalizadoProyectoF: '/api/view/Proyecto/MarcarFinalizadoProyectoF',

    verificarProveedorF: '/api/view/Proveedor/VerificarProveedorF',

    rechazarProveedorF: '/api/view/Proveedor/RechazarProveedorF',

    marcarConReservaProveedorF:
      '/api/view/Proveedor/MarcarConReservaProveedorF',

    verificarInsumoF: '/api/view/Insumo/VerificarInsumoF',

    discontinuarInsumoF: '/api/view/Insumo/DiscontinuarInsumoF',

    actualizarInsumoPrecio: '/api/view/Insumo/ActualizarInsumoPrecio',

    actualizarInsumoProveedorPrecio:
      '/api/view/InsumoProveedor/ActualizarInsumoProveedorPrecio',

    estimarInsumoPrecioF: '/api/view/Insumo/EstimarInsumoPrecioF',

    marcarPagadaComprasF: '/api/view/Compras/MarcarPagadaComprasF',

    marcarRecepcionadaComprasF: '/api/view/Compras/MarcarRecepcionadaComprasF',

    marcarCotizacionRecibidaComprasF:
      '/api/view/Compras/MarcarCotizacionRecibidaComprasF',

    solicitarCotizacionComprasF:
      '/api/view/Compras/SolicitarCotizacionComprasF',

    realizarPedidoComprasF: '/api/view/Compras/RealizarPedidoComprasF',
    imprimirCertificado: '/api/view/Certificado/ImprimirCertificado',
  },

  cotizacion: '/api/Cotizacion',

  maxNroCotizacion: '/api/Cotizacion/GetMaxNro',

  maxIdOrden: '/api/Orden/GetMaxId',
  maxIdCompra: '/api/Compras/GetMaxId',

  cotizacionParametros: {
    get: '/api/Cotizacion/GetParameters',
    edit: '/api/Cotizacion/EditParameters',
  },

  getLastStatusRevision: '/api/view/Cotizacion/GetLastStatusRevision',

  getLastStatusRevisionOrden: '/api/view/Orden/GetLastStatusRevision',

  getCotizacionDetalles: '/api/Cotizacion/GetCotizacionDetalles',

  cotizacionDetalle: '/api/CotizacionDetalle',

  orden: '/api/Orden',
  GetReciboByIdOrden: '/api/orden/GetReciboDetalleByIdOrden',
  GetRemitoByIdOrden: '/api/orden/GetRemitoDetalleByIdOrden',
  GetFacturaByIdOrden: '/api/orden/GetFacturaDetalleByIdOrden',
  ordenDetalle: '/api/OrdenDetalle',

  certificado: '/api/Certificado',
  certificadoDetalle: '/api/CertificadoDetalle',

  cliente: '/api/Cliente',
  getClienteById: '/api/Cliente/GetClienteById',

  rubro: '/api/Rubro',

  transporte: '/api/Transporte',

  contacto: '/api/Contacto',

  producto: '/api/Producto',

  productoStock: '/api/ProductoStock',

  produccion: '/api/Produccion',

  tipoProducto: '/api/TipoProducto',

  matriz: '/api/Matriz',

  matrizDisponible: '/api/Matriz/GetMatricesDisponibles',

  matrizProducto: '/api/view/Matriz',

  compuesto: '/api/Compuesto',

  formulacionCompuesto: '/api/FormulacionCompuesto',

  facturacion: '/api/Facturacion',
  maxNroFacturacion: '/api/Facturacion/GetMaxNro',

  facturacionDetalle: '/api/FacturacionDetalle',

  remito: '/api/Remito',
  maxNroRemito: '/api/Remito/GetMaxNro',

  remitoDetalle: '/api/RemitoDetalle',

  recibo: '/api/Recibo',
  maxNroRecibo: '/api/Recibo/GetMaxNro',

  reciboDetalle: '/api/ReciboDetalle',

  moneda: '/api/Moneda',

  proyecto: '/api/Proyecto',

  proyectoTareas: '/api/ProyectoTareas',

  tipoComprobante: '/api/TipoComprobante',

  puntoDeVenta: '/api/PuntoDeVenta',

  sistemaPtoVenta: '/api/SistemaPtoVenta',

  condicionIva: '/api/CondicionIva',

  actividad: '/api/Actividad',

  proveedor: '/api/Proveedor',

  insumo: '/api/Insumo',

  mensaje: '/api/Mensaje',
  maxIdMensaje: '/api/Mensaje/GetMaxId',
  GetBodyMessageById: '/api/Mensaje/GetBodyMessageById',

  tipoInsumo: '/api/TipoInsumo',

  unidadMedida: '/api/UnidadMedida',

  movimientoStock: '/api/MovimientoStock',

  insumoProveedorStock: '/api/InsumoProveedorStock',

  insumoProveedor: '/api/InsumoProveedor',

  productoInsumos: '/api/ProductoInsumos',

  compras: '/api/Compras',

  comprasDetalle: '/api/ComprasDetalle',

  getProveedorById: '/api/Proveedor/GetProveedorById',
};
